import InputUI from "@UI/InputUI";
import { Slider } from "primereact/slider";
import { useState } from "react";

const WeekDaysSlider = ({ value, item, week, weeksArray, handleWeekDays, isDisabled, dataId }) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className={`detail__item ${item.addClass || ""}`}>
            <label className={dataId.join("-")} data-pr-tooltip={item.label}>
                {item.label}
                {item.required ? "*" : ""}
            </label>

            <div className="slider-component__container" tabIndex={-1} onBlur={() => setIsOpen(false)}>
                <InputUI readOnly value={value ? `${week[value[0] - 1]} — ${week[value[1] - 1]}` : `${week[item.defaultValue[0] - 1]} — ${week[item.defaultValue[1] - 1]}`} onFocus={() => setIsOpen(true)} />

                {isOpen && (
                    <>
                        <Slider className="slider-component__slider" value={value || item.defaultValue} onChange={(e) => handleWeekDays(e.value)} min={1} max={8} step={1} range disabled={isDisabled} />

                        <div className="slider-component__dots">
                            {weeksArray.map((d, idx) => (
                                <div key={idx} className="slider-component__dot-item">
                                    {d}
                                </div>
                            ))}
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default WeekDaysSlider;
